import { useQuery } from '@apollo/client/react';
import { GET_CAMPAIGNS } from '../graphql/queries';
import { Campaign } from '../types/Campaign';

interface CampaignsData {
  getCampaignsForAdminPanel: Campaign[];
}

export const useCampaigns = () => {
  const { data, loading, error, refetch } = useQuery<CampaignsData>(GET_CAMPAIGNS);

  return {
    campaigns: data?.getCampaignsForAdminPanel || [],
    loading,
    error,
    refetch,
  };
};
